import { randomRange } from '../utils/math';

// Confetti Class
export class Confetti {
  public randomModifier: number;
  public color;
  public dimensions;
  public position: {
    x: number;
    y: number;
  };
  public rotation;
  public scale: {
    x: number;
    y: number;
  };
  public velocity: {
    x: number;
    y: number;
  };

  public update(drag: number, gravity: number, terminalVel) {
    // apply forces to velocity
    this.velocity.x -= this.velocity.x * drag;
    this.velocity.y = Math.min(this.velocity.y + gravity, terminalVel);
    this.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();

    // set position
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;

    // spin confetti by scaling y and set the color, .09 just slows cosine frequency
    this.scale.y = Math.cos((this.position.y + this.randomModifier) * 0.09);
  }

  constructor(colors: any[], canvas: HTMLCanvasElement, initConfettiVelocity: Function) {
    this.randomModifier = randomRange(0, 99);
    this.color = colors[Math.floor(randomRange(0, colors.length))];
    this.dimensions = {
      x: randomRange(5, 9),
      y: randomRange(8, 15)
    };
    this.position = {
      x: randomRange(canvas.width / 2, canvas.width / 2),
      y: randomRange(canvas.height / 2, canvas.height / 2)
    };

    this.rotation = randomRange(0, 2 * Math.PI);
    this.scale = {
      x: 1,
      y: 1
    };
    this.velocity = initConfettiVelocity([-9, 9], [6, 11]);
  }
}
